import type { RootState } from 'common/types'

export const selectHomeSearch = (state: RootState) => state.search.homeSearch
